// @flow
export { H1, H2, H3, H4, H5 } from 'components/Text';
